import React from 'react';
import { FormattedMessage } from 'react-intl';

import S from 'app/features/authentication/components/Login/LoginForgotPassword.styled';
import LocalizedLink from 'app/features/localization/components/LocalizedLink/LocalizedLink';
import ActionLink from 'app/components/Links/ActionLink.styled';
import CallToAction from 'app/components/layout/CallToAction.styled';
import { RESETPW_URL } from 'app/router/constants/externalUrls';

const LoginForgotPassword = () => (
  <S.LoginForgotPassword>
    <ActionLink
      type="silver"
      as={LocalizedLink}
      to={RESETPW_URL}
      testId="login-forgot-password-cta"
    >
      <CallToAction size="m" type="semibold">
        <FormattedMessage id="authentication_forgot_password" />
      </CallToAction>
    </ActionLink>
  </S.LoginForgotPassword>
);

LoginForgotPassword.displayName = 'LoginForgotPassword';

export default LoginForgotPassword;
